<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { service } from "../../../../../services/managements/services/service";
import { serviceType } from "../../../../../services/managements/services/servicetype.service";

import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Service List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        typeList: {},
        fetchingStats: false,
        title: "Service List",

        };
    },
    mounted() {
        
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
            this.fetchingStats = false;
            service.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
                this.loadServiceType();
                console.log()
            });
        },

        loadServiceType: function(param = '') {
            this.fetchingStats = false;
            serviceType.getList(param)
                .then(response => {
                this.fetchingStats = true;
                this.typeList = response;
            });
        },


        deleted: function(id) {
        service.remove(id)
            .then(response => {
            if(response.status == 200) {
                this.$swal.fire({
                title: i18n.t('general.confirm.deleted'),
                text: i18n.t('general.confirm.success'),
                icon: "success",
                confirmButtonText: i18n.t('general.ok')
                });
            }
            });
        },

        pageNavigate: function(param) {
        this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-setting-service-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-service-add'}" :title="$t('manage.service.text')" />
    <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name:'price', type: 'currency'}]"
          v-bind:fields="[ 
            `name: ${$t('manage.service.name')}`,
            `name_en: ${$t('manage.name_en')}`,
            `service_type: ${$t('manage.service-type.text')}`,
            `price: ${$t('manage.service-type.text')}`,
          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'manage-setting-service-edit'}"
          v-bind:filter="{
            search: ['mg_services.name','mg_services.name_en'],
            dropdown: [{
              title: 'manage.service.type',
              field: 'mg_services.service_type_id',
              data: this.typeList.data,
              width: 2
            }]
          }"
          
    />      
  </Layout>
</template>